import spartaMaskingDependencyUtility from '@sparta.global.utilities/sparta-masking-dependency-utility/dist/es6.js';
import Handlebars from '@sparta.global.vendors/handlebars';

// Constant for storing message strings.
const STRINGS = {
  MSG_NO_JCR: 'No JCR objects provided to helper.',
  MSG_JCR_ID: 'No ID found in JCR structure.'
};

/**
 * @method messagingHelper
 * @param {object} config JSON object used to build the msg group.
 * @param {object} context HTML that is between the item brackets.
 * @returns {Node} `Handlebars.SafeString`.
 */
function textMaskingHelper(config, context) {
  if (!config) {
    throw new Error(`${STRINGS.MSG_NO_JCR}:textMaskingHelper`);
  } else if (!config.id) {
    throw new Error(`${STRINGS.MSG_JCR_ID}:textMaskingHelper`);
  }

  // Does helper get generated from HBS or JS file
  // Note: The HBS rendered helper contains global data root while JS does not.
  // This allows us to render the JCR options into the DOM which HSB helper may need for utility events.
  let globalStrings = context && 'global' in context.data.root ? context.data.root.global.inputs.masking : {};

  // Load from spaParams
  if (Object.keys(globalStrings).length === 0 && typeof document !== 'undefined' && window && window.spaParams) {
    globalStrings = window.spaParams.global[window.spaParams.language].inputs.masking;
  }

  // Get from english defaults
  if (Object.keys(globalStrings).length === 0) {
    globalStrings = {
      actions: {
        hide: 'Hide',
        show: 'Show'
      },
      inactive: 'The value of this field will be hidden from view when not active',
      instructions: {
        default: 'this value',
        message: '(the value will be hidden again in 5 seconds)'
      },
      securityText: 'This value has been hidden for security reasons'
    };
  }

  // The basics
  const {
    id
  } = config;
  const {
    classes = ''
  } = config;
  const {
    label = ''
  } = config;
  const {
    tagType = 'p'
  } = config;
  const {
    hint = ''
  } = config;
  const {
    defaultState = 'masked'
  } = config;
  const {
    disableMaskToggleBtn
  } = config;
  const maskedState = defaultState === 'masked' ? globalStrings.actions.show : globalStrings.actions.hide;

  // Mask the given value on render
  const {
    unmaskedValue
  } = config;
  const {
    maskedType = 'basic'
  } = config;
  const maskedValue = maskedType && unmaskedValue ? spartaMaskingDependencyUtility.fn.maskingRules[maskedType](unmaskedValue) : '';

  // Toggle button config
  const {
    toggleBtn
  } = config;
  const buttonNiceName = maskedState.charAt(0).toUpperCase() + maskedState.slice(1);
  const buttonAdaLabel = toggleBtn && 'ariaLabel' in toggleBtn ? toggleBtn.ariaLabel : label.length > 0 ? label : globalStrings.instructions.default;
  let toggleAriaLabel = `${buttonNiceName} ${buttonAdaLabel} ${globalStrings.instructions.message}`;
  toggleAriaLabel = defaultState === 'unmasked' ? toggleAriaLabel.replace(globalStrings.instructions.message, '') : toggleAriaLabel;

  // DOM element creation
  const content = `
    <${tagType} 
      id="${id}"
      class="masked-element masked-element--helper ${classes}"
      data-masked-state="${defaultState}"
      ${maskedType ? `data-field-type="${maskedType}"` : ''}
      tabindex="-1"
    >
      <span class="data-value" role="status">
        <span class="label">${label}</span>
        <span class="masking-value" data-value-unmasked="${unmaskedValue}" data-value-masked="${maskedValue}">${defaultState === 'unmasked' ? unmaskedValue : maskedValue}</span>
      </span>
      <span class="ada-hidden">${globalStrings.securityText}</span>
      <button
        type="button"
        class="gis-mask ${maskedType ? `gis-mask--${maskedType}` : ''} spa-btn spa-btn--link"
        aria-label="${toggleAriaLabel.trim()}"
        data-ada-label="${buttonAdaLabel}"
        ${disableMaskToggleBtn ? `data-enable-toggle="${disableMaskToggleBtn}"` : ''}
      >
        ${buttonNiceName}
      </button>
      ${hint ? `<span class="masked-element--hint">${hint}</span>` : ''}
    </${tagType}>
  `;
  return new Handlebars.SafeString(content.replace(/(\s\s+|[\t\n])/g, ' ').trim());
}

export { textMaskingHelper };
